module.exports = __webpack_public_path__ + "media/images/emoticons/wink-547a373b6eb3840f76df4d2dbeb66afc.gif";